<template>
  <el-dialog title="修改患者信息" :visible.sync="dialogVisible" width="600px" center destroy-on-close	>
    <el-form :model="editForm">
      <el-form-item label="姓名" :label-width="formLabelWidth">
        <el-input v-model="editForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="手机号" :label-width="formLabelWidth">
        <el-input v-model="editForm.tel" autocomplete="off"></el-input>
      </el-form-item>
<!--      <el-form-item label="医院" :label-width="formLabelWidth">-->
<!--        <el-select v-model="editForm.hospital_name" allow-create filterable default-first-option placeholder="医院">-->
<!--          <el-option-->
<!--            v-for="hospital_name in hospitalColumns"-->
<!--            :label="hospital_name"-->
<!--            :value="hospital_name"-->
<!--            :key="hospital_name"-->
<!--          ></el-option>-->
<!--        </el-select>-->
<!--      </el-form-item>-->
      <el-form-item v-if="!isDis" label="医院" :label-width="formLabelWidth">
        <el-select v-model="editForm.hospital_name" allow-create filterable default-first-option placeholder="医院">
          <el-option
            v-for="hospital_name in hospitalColumns"
            :label="hospital_name"
            :value="hospital_name"
            :key="hospital_name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务时间" :label-width="formLabelWidth">
        <el-row type="flex" :gutter="20">
          <el-col style="width: auto">
            <el-date-picker
              v-model="editForm.start_at"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              style="width: 140px"
              @change="handelChangeStartDate"
            />
          </el-col>
          <el-col style="width: auto"> - </el-col>
          <el-col style="width: auto">
            <el-date-picker
              v-model="editForm.end_at"
              type="date"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              style="width: 140px"
            />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="详细地址" :label-width="formLabelWidth">
        <el-input v-model="editForm.address" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="!isDis"  label="病床" :label-width="formLabelWidth">
        <el-input v-model="editForm.bed_no" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="isDis" label="残疾证号" :label-width="formLabelWidth">
        <el-input v-model="editForm.id_card" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item v-if="isDis" label="残疾证照" :label-width="formLabelWidth" label-position="top">
        <el-upload
          action='#'
          :http-request="uploadFile"
          list-type="picture-card"
          :limit="9"
          :file-list="fileList"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pictureCompress from 'picture-compressor'
import { editOrderUserInfoById, fetchHospitalPList, uploadImgs } from '../../../api'

export default {
  name: 'ChangeOrderPatientInfo',
  props: {
    type: {
      type: null,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: '123px',
      editForm: {
        start_at: '',
        end_at: '',
        id_card: '',
        order_id: '',
        name: '',
        tel: '',
        hospital_name: '',
        address: '',
        bed_no: ''
      },
      fileList: [],
      hospitalColumns: [
        // '全部',
        // '潜山市立医院',
        // '潜山市中医院',
        // '梅城镇卫生院',
        // '王河镇卫生院',
        // '源潭镇卫生院',
        // '余井镇卫生院',
        // '黄泥镇卫生院',
        // '槎水镇卫生院',
        // '官庄镇卫生院',
        // '水吼镇卫生院',
        // '黄柏镇卫生院',
        // '黄铺镇卫生院',
        // '天柱山镇卫生院',
        // '油坝乡卫生院',
        // '痘姆乡卫生院',
        // '塔畈乡卫生院',
        // '五庙乡卫生院',
        // '龙潭乡卫生院',
        // '潜山同和医院',
        // '潜山同春医院',
        // '潜山东华医院',
        // '潜山朝阳医院',
        // '安庆市立医院',
        // '合肥四院'
      ],
      service_days_num: 0
    }
  },
  computed: {
    isDis() {
      return this.type === 'orders_foster' || this.type === 'orders_foster_records'
    }
  },
  methods: {
    async handleOpen(val) {
      const { orderInfo: { id: order_id, service_days_num, id_card, img_urls }, userInfo: { name = '', start_at = '', end_at = '', tel = '', hospital_name = '', address = '', bed_no = '' } } = val
      this.editForm = {
        start_at: start_at * 1000,
        end_at: end_at * 1000,
        id_card,
        order_id, name, tel, hospital_name, address, bed_no
      }
      this.fileList = img_urls && img_urls !== '' ? img_urls.split(',').map(i => {
        return {
          url: i
        }
      }) : []
      this.service_days_num = service_days_num
      if (!this.isDis) {
        await this.fetchHospital()
      }
      this.dialogVisible = true
    },
    async fetchHospital() {
      await fetchHospitalPList().then(res => {
        if (res.status) {
          this.hospitalColumns = [
            ...res.data.list.map(i => {
              return i.hospital_name
            })
          ]
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handelChangeStartDate(e) {
      if (!this.editForm.start_at) return
      const { service_days_num, editForm: { start_at: newV } } = this
      const newVl = new Date(newV)
      this.editForm.end_at = new Date(newVl).setDate(newVl.getDate() + service_days_num - 1)
    },
    handleRemove(file) {
      this.fileList.map((fileData, key) => {
        if (fileData.uid === file.uid) {
          this.fileList.splice(key, 1)
        }
      })
    },
    uploadFile(item) {
      const _this = this
      const reader = new FileReader()
      reader.readAsDataURL(item.file)
      reader.onload = function() {
        pictureCompress({
          img: reader.result,
          width: 500,
          height: 500
        }).then(res => {
          const params = {
            data: res.img,
            fileName: item.file.uid
          }
          uploadImgs(params)
            .then(resp => {
              if (resp.status) {
                _this.fileList.push({ uid: item.file.uid, ...resp.data })
              }
            })
            .catch(() => {

            })
        })
      }
    },
    handleSubmit() {
      const { isDis } = this
      const { order_id, id_card, name, tel, hospital_name, address, bed_no, start_at, end_at } = this.editForm
      const img_urls = this.fileList.map((fileData) => fileData.url).join(',')
      if (!name) return this.$message({ message: '请填写姓名！', type: 'warning' })
      if (!tel) return this.$message({ message: '请填写手机号！', type: 'warning' })
      if (!isDis) {
        if (!hospital_name) return this.$message({ message: '请填写医院名称！', type: 'warning' })
        if (!bed_no) return this.$message({ message: '请填写床位号！', type: 'warning' })
      }
      if (!address) return this.$message({ message: '请填写详细地址！', type: 'warning' })
      if (!start_at) return this.$message({ message: '请选择时间！', type: 'warning' })
      if (!end_at) return this.$message({ message: '请选择时间！', type: 'warning' })
      const params = {
        order_id, name, tel, hospital_name, address, bed_no,
        start_at: parseInt(new Date(start_at).getTime() / 1000),
        end_at: parseInt(new Date(end_at).getTime() / 1000),
        id_card,
        img_urls
      }
      editOrderUserInfoById(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style scoped>

</style>
